import CallError from '../../../utils/CallError';
import Settings from '../../../utils/Settings';
import { getBadParams, getMissingKeys } from '../../../utils/general';
import appDetails from './app-details';
import browse from './browse';
import publisherDetails from './publisher-details';

export const settings = new Settings();

export const checkMissingParams = (params, requiredParams, paramsRules) => {
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
};

export const fetchCCESExtensions = async (signal, requestBody, authToken) => {
  const endpoint = authToken ? settings.endpoint : settings.endpoint + '/unauth';

  const headers = new Headers({
    'x-api-key': settings.apiKey,
    Accept: 'application/vnd.adobe-ccextension.extension-list-v4+json',
    'Content-Type': 'application/vnd.adobe-ccextension.extension-filter-v3+json',
    'x-gw-ims-user-id': 'NA',
  });

  if (authToken) {
    headers.append('Authorization', authToken);
  }

  const response = await fetch(`${endpoint}/v3/extensions`, {
    signal,
    method: 'POST',
    headers,
    body: JSON.stringify(requestBody),
  });
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }
  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return content;
  }
};

export default async (params = {}, signal = null) => {
  let content;
  switch (params.resultType) {
    case 'card':
      content = await browse(params, signal);
      break;
    case 'details':
      content = await appDetails(params, signal);
      break;
    case 'publisher':
      content = await publisherDetails(params, signal);
      break;
    default:
      throw new CallError(
        'params',
        null,
        404,
        'Wrong resultType param. Allowed values: "card", "publisher", "details"'
      );
  }
  return content;
};
